<template>
  <div ref="audio_container">
    <a-slider
      class="max_300 slider_contianer"
      :marks="marks"
      :included="false"
      :default-value="100"
      @change="onChange"
      :max="200"
      :min="100"
      :step="null"
      :tooltipVisible="false"
    />
    <a-space align="center">
      <audio :src="url" controls preload="metadata" ref="audio"></audio>
      <AudioReason :url="url" :aliyunAudit="aliyunAudit" v-if="visible" :xid="xid">
        <a-icon type="exclamation-circle" />
      </AudioReason>
      <!-- <a-button type="link" :disabled="loading || !!parseText" style="padding: 0 4px;" @click="transferText">转文字</a-button> -->
    </a-space>

    <div style="text-align: center" class="max_300" v-if="loading">
      <img src="../../assets/loadding.gif" />
    </div>
    <a-popover placement="right" :getPopupContainer="() => $refs.audio_container" :content="parseText" :overlayStyle="overlayStyle">
      <div class="max_300 parse_text">{{ parseText }}</div>
    </a-popover>
  </div>
</template>

<script>
import AudioReason from './AudioReason'
import { audioRecognize } from '@/api/review'
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    aliyunAudit: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    },
    xid: {
      type: String,
      required: false
    }
  },
  components: { AudioReason },
  data() {
    return {
      marks: {
        100: '1倍速',
        125: '1.25倍速',
        150: '1.5倍速',
        175: '1.75倍速',
        200: '2倍速'
      },
      loading: false,
      parseText: '',
      transferReg: /^(http|https):\/\/.*.(aac|mp3|opus|wav)$/,
      overlayStyle: {'max-width': '430px', 'max-height': '340px', 'overflow-y': 'auto', 'box-shadow': '0 2px 8px rgb(0 0 0 / 15%)', 'padding': 0 }
    }
  },
  methods: {
    onChange(value) {
      this.$refs['audio'].playbackRate = value / 100
    },
    transferText () {
      const audioUrl = this.url
      if (!this.transferReg.test(audioUrl)) {
        return this.$message.error('仅支持acc、mp3、opus、wav类型的语音')
      }
      this.loading = true
      audioRecognize({ audioUrl }).then(res => {
        this.loading = false
        const { code, result, message } = res
        if (code == 1) {
          this.parseText = result
        }
      })
    }
  }
}
</script>

<style scoped>
.slider_contianer {
  margin-bottom: 36px;
}
.max_300 {
  max-width: 300px;
}
.parse_text {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 20px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
